/**
 * Wyświetlanie: „123 EUR” / sama etykieta „EUR” → znak euro (tylko front).
 * Wcześniej w Theme Options → Custom CSS/JS — przeniesione do motywu,
 * żeby nie ginęło przy syncu / czyszczeniu opcji.
 */
const EUR_RE = /(\d)[\u00A0\u202F ]?EUR\b/g;
const EUR_NBSP = `\u00A0€`;
const SKIP = /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT)$/;

const fixNode = (node) => {
  if (node.nodeType === Node.TEXT_NODE) {
    const raw = node.nodeValue;
    if (raw.trim() === 'EUR') {
      if (/currency/.test(String(node.parentNode?.className || ''))) {
        node.nodeValue = '€';
      }
      return;
    }
    const next = raw.replace(EUR_RE, (_, digit) => digit + EUR_NBSP);
    if (next !== raw) node.nodeValue = next;
    return;
  }
  if (node.nodeType !== Node.ELEMENT_NODE) return;
  if (SKIP.test(node.nodeName)) return;

  const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
  let current;
  while ((current = walker.nextNode())) {
    if (current.parentNode && SKIP.test(current.parentNode.nodeName)) continue;
    fixNode(current);
  }
};

export default function displayEuroSymbol() {
  if (typeof document === 'undefined') return;
  const run = () => {
    if (!document.body) return;
    fixNode(document.body);
    new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.type === 'characterData') {
          fixNode(m.target);
          return;
        }
        m.addedNodes.forEach(fixNode);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  if (document.body) run();
  else document.addEventListener('DOMContentLoaded', run);
}
